const FreeShippingIcon = ({ width = "20px", height = "20px" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
  >
    <path
      fill="#F95"
      d="M8.8 0C8 0 7.5.6 7.5 1.3V10c0 .7.6 1.3 1.3 1.3h10c.6 0 1.2-.6 1.2-1.3V1.3c0-.7-.6-1.3-1.3-1.3h-10Z"
    />
    <path
      fill="#E4EFF8"
      d="M12.2 0v3.8c0 .2.2.3.4.2l1.2-.5 1 .5c.3.1.5 0 .5-.2V0h-3.1Z"
    />
    <path
      fill="#FFC6A0"
      d="M18.1 14.6c-.2-.6-.8-.9-1.4-.7l-4.6 1.6c0-.3-.2-.6-.6-.8l-3.2-1.9s-.7-.4-1.7-.4c-.8 0-1.8.5-2.8 1.1v5.2l1.8-.3c.3 0 .8.4 1.4.8.6.4 1.3.8 2 .8a44.2 44.2 0 0 0 8.4-4c.6-.3 1-.9.7-1.4Z"
    />
    <path fill="#FFAF7A" d="M3.8 13.5v5.2l.9-.2v-5l-.1-.4-.8.4Z" />
    <path
      fill="#FFAF7A"
      d="M17.5 15.3a96.5 96.5 0 0 1-6.4 3.4 6 6 0 0 1-2 .7c-.8 0-1.5-.5-2.1-.9-.6-.4-1-.7-1.4-.7a9.8 9.8 0 0 0-1.8.2v.7l1.8-.3c.3 0 .8.4 1.4.8.6.4 1.3.8 2 .8a44.2 44.2 0 0 0 8.4-4c.6-.3.9-.8.7-1.4 0 .3-.3.6-.6.7Z"
    />
    <path
      fill="#FFAF7A"
      d="M8.7 15.2c-.3-.2-.6.4-.3.6l1.9 1c.6.4 1.3.2 1.7-.4.3-.5.2-1-.1-1.4.2.3.2.7 0 1a1 1 0 0 1-1.3.3l-1.9-1Z"
    />
    <path
      fill="#549AD4"
      d="M.6 12.8c-.3 0-.6.3-.6.6v5.7c0 .3.3.6.6.6h2.8c.4 0 .7-.3.7-.6v-5.7c0-.3-.3-.6-.7-.6H.6Z"
    />
    <path fill="#E4EFF8" d="M1.6 18.4a.3.3 0 1 1-.7 0 .3.3 0 0 1 .7 0Z" />
    <path
      fill="#3588CB"
      d="M1.3 19a.6.6 0 0 1-.7-.6v-5.6c-.3 0-.6.3-.6.6v5.7c0 .3.3.6.6.6h2.8c.4 0 .7-.3.7-.6H1.3Z"
    />
    <path fill="#C4DCF0" d="M12.2 0v3.8c0 .2.2.3.4.2h.3V0h-.7Z" />
    <path
      fill="#FF7F29"
      d="M8.2.1c-.4.2-.7.6-.7 1.2V10c0 .7.6 1.3 1.3 1.3h10c.5 0 .9-.4 1-.8l-.4.1h-10c-.7 0-1.3-.5-1.3-1.2V.6l.1-.5Z"
    />
    <path fill="#ECB200" d="M5 2.5c-.4 0-.4.6 0 .6h1.3c.4 0 .4-.6 0-.6H5Z" />
    <path fill="#FFCA28" d="M.3 3.7c-.4 0-.4.7 0 .7h3.8c.4 0 .4-.7 0-.7H.3Z" />
    <path fill="#ECB200" d="M2.5 5.6c-.4 0-.4.7 0 .7H5c.4 0 .4-.7 0-.7H2.5Z" />
    <path fill="#FFCA28" d="M1 7.5c-.5 0-.5.6 0 .6h3c.5 0 .5-.6 0-.6H1Z" />
    <path
      fill="#E4EFF8"
      d="M15.6 8.1c-.1 0-.3.1-.3.3v1c0 .4.6.4.6 0v-1c0-.2-.1-.3-.3-.3ZM16.9 8.1c-.2 0-.3.1-.3.3v1c0 .4.6.4.6 0v-1c0-.2-.2-.3-.3-.3ZM18.1 8.1c-.1 0-.3.1-.3.3v1c0 .4.6.4.6 0v-1c0-.2-.1-.3-.3-.3Z"
    />
  </svg>
);

export default FreeShippingIcon;
